import React from 'react'
import PrivacyPolicy from '../../components/Navbar/PrivacyPolicy'

function PrivacyPolicyPage() {
  return (
<PrivacyPolicy/>
  )
}

export default PrivacyPolicyPage;